import React from 'react';

function ClassFooter({ footerData, isLoading }) {
    // Igual que en el HomeFooter, extraemos el primer elemento
    const config = footerData && footerData.length > 0 ? footerData[0] : null;

    return (
        <footer className="class-footer-container">
            <div className="class-wavy-band">
                <div className="footer-social-icons">
                    {!isLoading && config ? (
                        <>
                            {config.social_facebook && (
                                <a href={config.social_facebook} target="_blank" rel="noopener noreferrer">
                                    <i className="ri-facebook-fill"></i>
                                </a>
                            )}
                            {config.social_instagram && (
                                <a href={config.social_instagram} target="_blank" rel="noopener noreferrer">
                                    <i className="ri-instagram-line"></i>
                                </a>
                            )}
                            {config.social_linkedin && (
                                <a href={config.social_linkedin} target="_blank" rel="noopener noreferrer">
                                    <i className="fa-brands fa-linkedin"></i>
                                </a>
                            )}
                        </>
                    ) : null}
                </div>
            </div>
        </footer>
    );
}

export default ClassFooter;